export const noteKeys = {
  get: (workOrderOperationId?: string | null) =>
    ["notes", workOrderOperationId] as const,
};
